import React, { useState, useEffect, useRef } from 'react'
import { v4 as uuid } from 'uuid'
import ReportsService from '../../../../../services/reports.service'
import { BlockingLoader, Modal, MuiButton, Confirmation } from '../../../../../components'
import { fakeDelay, getSnapshotUpdatedJson_AddRowColFunc, generateSnapshotWidgetRowsAndColsFunc } from '../../../../../util'
import { IconConfigureStructure, IconPlus } from '../../../../../assets/images/iconsV2'
import AddWidget from '../addWidget'
import { Wrapper, TitleWrapper, WidgetOuterWrapper, WidgetWrapper, ActionWrapper, PrintBreak } from './style'

const ReportEditSnapshot = (props) => {
  const { InsightsElementId, pageData, onSuccess, title } = props
  const [anchorElUser, setAnchorElUser] = useState(null)
  const [showEditHeaderModal, setShowEditHeaderModal] = useState(false)
  const [widgetArray, setWidgetArray] = useState(pageData || [])
  const [widgetObject, setWidgetObject] = useState({})
  const [draggedItem, setDraggedItem] = useState(null)
  const [loader, setLoader] = useState(false)
  const [saveStructureDisabled, setSaveStructureDisabled] = useState(false)
  const [deleteConfirmationObject, setDeleteConfirmationObject] = useState(false)
  const initWidget = {
    id: 1,
    orderBy: 0,
    width: 1,
    height: 1,
    title: ''
  }
  const wrapperWidth = 1080

  function getGUID() {
    return uuid();
  }

  const handleOnEditHeader = () => {
    setAnchorElUser(null)
    setShowEditHeaderModal((prev) => !prev)
    onSuccess()
  }

  const addWidgetFunc = () => {
    const maxValue = widgetArray.map(d => d.id)
    const newId = widgetArray?.length > 0 ? Math.max(...maxValue) + 1 : 1
    setWidgetArray([...widgetArray, {...initWidget, guid:getGUID(), id:newId, orderBy:widgetArray.length, title: ''}])
  }

  const addWidgetChanged = (d) => {
    const attachToArray = widgetArray.map(obj => (obj.orderBy === d.orderBy ? d : obj))
    setWidgetArray(attachToArray)
  }

  const deleteWidget = () => {
    const d = deleteConfirmationObject
    const attachToArray = widgetArray.filter(f => f.guid !== d.guid)
    setWidgetArray(attachToArray)
    setDeleteConfirmationObject(null)
  }

  const addRowNumberFunc = async () => {
    const colH = 80
    const dynamicGridId = document.getElementById('dynamicGrid')
    if(dynamicGridId && document.querySelector('.rowsLegend')){
      dynamicGridId.querySelector('.rowsLegend').innerHTML = ''

      await fakeDelay(10)
      const getWrapperHeight = dynamicGridId.getBoundingClientRect().height
      const totalRows = Math.round(getWrapperHeight/colH)
      let html = ''
      for(let i=0; i<totalRows-1; i++){
        html += `${i+1}<br />`
        if(i>=2 && (i+1)%3 === 0){
          html += `<hr style='top: ${(i+1)*colH}px' />`
        }
      }
      dynamicGridId.querySelector('.rowsLegend').innerHTML = html
    }
  }

  const onSubmit = (e) => {
    e.preventDefault()

    const widgetArr = getSnapshotUpdatedJson_AddRowColFunc(widgetArray)

    const updatedValues = {
      insightsElementId: InsightsElementId,
      snapshotLayoutElements : widgetArr.map((d, i) => {
        return {
          SnapshotLayoutElement: {
            SnapshotWidgetId: d.guid,
            SnapshotWidgetNumber: i+1,
            SnapshotWidgetLocationRow: d.row,
            SnapshotWidgetLocationColumn: d.col,
            SnapshotWidgetHeight: d.height,
            SnapshotWidgetWidth: d.width,
          }
        }
      })
    }

    setLoader(true)
    ReportsService.reportSetSnapshotLayoutApi(updatedValues)
      .then((resp) => {
        setTimeout(() => {
          setShowEditHeaderModal(false)
          setLoader(false)
          onSuccess(widgetArray)
        }, 2000)
        // onSuccess()
      })
      .catch((error) => {
        setLoader(false)
        const resMessage = error
        console.log('ERROR : ', resMessage)
        // enqueueSnackbar(resMessage, { variant: 'error' })
      })
  }

  useEffect( () => {
    const updatedData = generateSnapshotWidgetRowsAndColsFunc(widgetArray, 'edit', wrapperWidth)
    setWidgetObject(updatedData)
    addRowNumberFunc()
  }, [widgetArray])

  useEffect( () => {
    addRowNumberFunc()
  }, [showEditHeaderModal])

  useEffect(() => {
    if(widgetObject?.gridTemplateColumns){
      const col = (widgetObject.gridTemplateColumns.split(',')[0].split('(')[1])*1
      setSaveStructureDisabled(col!==4)
    }
  }, [widgetObject])

  const DescriptionData = () => {
    return (
      <>
        {deleteConfirmationObject?.json?.length > 0 
          ? <p><b style={{color:'#EE2534'}}>This widget contains content.</b> Deleting it will permanently remove all configured data for this block and structure will rearrange.</p>
          : <p>This widget doesnt contain any configured content. Deleting it will remove the block from your layout and structure will rearrange.</p>}
      </>
    )
  }

  const getDisplayFunc = () => {
    const w = (widgetObject?.data?.[0] || []).map(d => d.width).reduce((acc, val) => acc + val, 0);
    return (w < 4) ? 'flex' : 'grid'
  }
  
  return (
    <>
      <MuiButton
        startIcon={<IconConfigureStructure />}
        color='light'
        variant='outlined'
        label='Configure Structure'
        onClick={() => setShowEditHeaderModal(true)}
      />

      {showEditHeaderModal && (
        <Modal title='Configure Snapshot Layout' showClose={true} onClose={handleOnEditHeader} styleType='themeV2'>
          <Wrapper style={{width:wrapperWidth+'px'}}>
            <TitleWrapper>Define Structure <MuiButton size='small' color='primary' variant='text' startIcon={<IconPlus />} label={'Add Widget'} onClick={() => addWidgetFunc()} /></TitleWrapper>
            <WidgetOuterWrapper>
              <WidgetWrapper id='dynamicGrid' style={{gridTemplateColumns: widgetObject.gridTemplateColumns, display: getDisplayFunc() }}>
                <span className='colsLegend'></span>
                <span className='rowsLegend'></span>
                {
                  widgetObject && widgetObject?.data?.length > 0 && widgetObject.data.map((d, i) => {
                    return (
                      <>
                        {d.map((obj, j) => 
                          (<AddWidget
                            data={obj} key={obj.id} index={obj.orderBy} onChange={(e) => addWidgetChanged(e)}
                            draggedItem={draggedItem} setDraggedItem={(d) => setDraggedItem(d)}
                            onDelete={(e) => setDeleteConfirmationObject(e)} widgetArray={widgetArray} setWidgetArray={arr => setWidgetArray(arr)}
                          />)
                        )}
                      </>
                    )
                  })
                }
              </WidgetWrapper>
            </WidgetOuterWrapper>
            <ActionWrapper>
              <MuiButton
                color='gray'
                variant='contained'
                onClick={() => handleOnEditHeader()}
                label='Cancel'
              />
              <PrintBreak>Print Break</PrintBreak>
              <MuiButton
                color='primary'
                variant='contained'
                onClick={onSubmit}
                disabled={saveStructureDisabled}
                label='Save Structure'
              />
            </ActionWrapper>
          </Wrapper>
        </Modal>
      )}

      {loader && <BlockingLoader />}

      {deleteConfirmationObject && <Confirmation
        open={true}
        title={'Are you sure you want to delete this widget?'}
        description={<DescriptionData />}
        onCancel={() => setDeleteConfirmationObject(null)}
        onSubmit={() => deleteWidget()}
        submitMsg = 'Delete'
        cancelMsg = 'Cancel'
      />}
    </>
  )
}

export default ReportEditSnapshot
